import React, { useState, Fragment } from 'react'
import { useMutation } from 'react-apollo-hooks'
import { Confirm } from '../../application'
import getText from '../strings'
import { colors, Message } from '../../styles'
import styled from 'react-emotion'
import * as Mutations from '../mutations'
import { useAuth } from '../../authContext'

const Flex = styled('div')`
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
  align-items: center;
  a {
    color: ${colors.tui_red};
    cursor: pointer;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    a {
      margin-top: 10px;
      display: block;
    }
  }
`

export default () => {
  const { actions } = useAuth()
  const [error, setError] = useState(false)
  const deleteCustomerAccount = useMutation(Mutations.deleteCustomerAccount)

  const deleteAccount = () => {
    setError(false)
    deleteCustomerAccount({
      update: (proxy, mutationResult) => {
        if (mutationResult.data.deleteCustomerAccount) {
          actions.logout()
        } else {
          setError(true)
        }
      }
    })
  }

  return (
    <Fragment>
      <Flex>
        <div>
          <h4>{getText('delete', 'deleteAccount')}</h4>
          {getText('delete', 'deleteAccountInformation')}
        </div>
        <div>
          <Confirm
            question={getText('delete', 'deleteAccountConfirm')}
            onResult={res => res && deleteAccount()}
            Opener={() => <a>{getText('delete', 'deleteMyAccount')}</a>} />
        </div>
      </Flex>
      {error &&
        <Message error={true}>{getText('errors', 'general')}</Message>
      }
    </Fragment>
  )
}